import { render, staticRenderFns } from "./skinPackageFive.vue?vue&type=template&id=1e7fbaa7&scoped=true"
import script from "./skinPackageFive.vue?vue&type=script&lang=js"
export * from "./skinPackageFive.vue?vue&type=script&lang=js"
import style0 from "./skinPackageFive.vue?vue&type=style&index=0&id=1e7fbaa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7fbaa7",
  null
  
)

export default component.exports